<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <b-row v-if="loaded" class="mx-0 mb-3">
      <b-col lg="6" sm="12">
        <b-card class="shadow bg-light" no-body>
          <b-card-header header-text-variant="light" header-tag="h6">
            Tableau comptable (résumé)
            
            <date-range-picker
              @update="updateChart"
              :key="updateRender"
              showDropdowns
              class="float-right"
              v-model="dateRange"
              :ranges="ranges"
              :locale-data="localeData"
            ></date-range-picker>
          </b-card-header>
          <b-card-body>
            <b-table v-if="!noData" striped hover :items="summary" :fields="summaryFields">
              <template v-slot:bottom-row>
                <td>
                  <strong>Total</strong>
                </td>
                <td>
                  <strong>
                    <span
                      class="float-right"
                    >{{ summary.reduce( (a, b) => Number(a) + Number(b.total), 0 ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) }} €</span>
                  </strong>
                </td>
                <td>
                  <strong>
                    <span
                      class="float-right"
                    >{{ summary.reduce( (a, b) => Number(a) + Number(b.totalTVA), 0 ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) }} €</span>
                  </strong>
                </td>
                <td>
                  <strong>
                    <span
                      class="float-right"
                    >{{ summary.reduce( (a, b) => Number(a) + Number(b.total) + Number(b.totalTVA), 0 ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) }} €</span>
                  </strong>
                </td>
              </template>
            </b-table>
            <b-card-text v-else>Pas de données pour cette période</b-card-text>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col lg="6" sm="12">
        <b-card
          class="shadow bg-light"
          header="Graphique"
          header-text-variant="light"
          header-tag="h6"
        >
          <b-row>
            <b-col sm="5" offset-sm="1">
              <b-form-select
                @change="updateChart"
                v-model="selectedChartType"
                :options="chartType"
                class="mb-3"
              ></b-form-select>
            </b-col>
            <b-col sm="5">
              <b-form-select
                @change="updateChart"
                v-model="selectedVATType"
                :options="VATType"
                class="mb-3"
              ></b-form-select>
            </b-col>
          </b-row>
          <b-row align-v="center">
            <b-col sm="1">
              <b-button @click="previousTime">
                <b-icon-arrow-left></b-icon-arrow-left>
              </b-button>
            </b-col>
            <b-col sm="10">
              <highcharts :options="charted" ref="chart"></highcharts>
            </b-col>
            <b-col sm="1">
              <b-button @click="nextTime">
                <b-icon-arrow-right></b-icon-arrow-right>
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-if="loaded">
      <b-col sm="12">
        <bd-table-list
          nobreadcrumb
          nofacets
          nosearch
          nofloatingPagination
          title="Factures"
          bdTable="facture"
          :key="componentKey"
          :query="query"
          :actions="actions"
          :fields="fields"
          :Api="Api"
        ></bd-table-list>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import invoices from "@/services/invoices.js";
import BdTableList from "@/components/BdTableList";
import DateRangePicker from "vue2-daterange-picker";
import String from "@/services/String.js";
import DateTime from "@/services/DateTime.js";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import moment from "moment";
import { Chart } from "highcharts-vue";
export default {
  name: "chart-accounts",
  components: {
    DateRangePicker,
    highcharts: Chart,
    BdTableList
  },
  data() {
    return {
      componentKey: 0,
      updateRender: 0,
      Api: invoices,
      query: [],
      fields: [
        {
          key: "ID",
          label: "N° de facture",
          sortable: true,
          class: "text-right",
          thStyle: "width:100px"
        },
        {
          key: "date",
          label: "Date",
          sortable: true,
          formatter: value => {
            return this.toDate(value);
          }
        },
        {
          key: "creancier",
          label: "Créancier",
          thStyle: "width:450px",
          sortable: true,
          formatter: (value, key, item) => {
            let nom = " (" + (item.prenom + " " + item.nom).trim() + ")";
            return (
              '<a href="/creditor/view/' +
              item.creancierID +
              '">' +
              this.company(value) +
              nom +
              "</a>"
            );
          }
        },
        {
          key: "type",
          label: "Type",
          sortable: true
        },
        {
          key: "mandat_prix_unitaire",
          label: "Prix unitaire",
          sortable: true,
          class: "text-right",
          formatter: value => {
            return value ? value + " €" : "";
          }
        },
        {
          key: "prixHTVA",
          label: "Prix HTVA",
          sortable: true,
          class: "text-right",
          formatter: value => Number(value).toFixed(2) + " €"
        },
        {
          key: "tva",
          label: "TVA",
          sortable: true,
          class: "text-right",
          formatter: (value, key, item) => {
            return (
              (item.prixHTVA * value).toFixed(2) +
              " € (" +
              item.tva * 100 +
              " %)"
            );
          }
        },
        {
          key: "tvac",
          label: "TVAC",
          sortable: true,
          class: "text-right",
          formatter: (value, key, item) => {
            return (item.prixHTVA * (1 + item.tva)).toFixed(2) + " €";
          }
        },

        {
          key: "releve_compteID",
          label: "Relevé",
          sortable: true,
          formatter: value => (value ? value : "N/A")
        }
      ],
      actions: [
        {
          label: "Visualiser",
          to: "invoiceView"
        },
        {
          label: "Éditer"
        },
        {
          label: "Paiement"
        },
        {
          label: "Envoyer par mail"
        },
        {
          label: "Imprimer"
        },
        {
          label: "Supprimer"
        }
      ],
      loaded: false,
      noData: true,
      selectedVATType: 1,
      VATType: [
        { value: 1, text: "Hors TVA" },
        { value: 2, text: "Montant de la TVA" },
        { value: 3, text: "TVA comprise" }
      ],
      selectedChartType: "month",
      chartType: [
        { value: "year", text: "Par année" },
        { value: "month", text: "Par mois" },
        { value: "day", text: "Par jour" }
      ],
      charted: {
        chart: {
          events: {
            load() {
              this.showLoading();
            }
          }
        },
        series: [
          {
            data: []
          }
        ]
      },
      dateRange: {
        startDate: moment()
          .subtract(6, "months")
          .date(1),
        endDate: moment()
      },
      localeData: {
        direction: "ltr",
        format: "dd/mm/yyyy",
        separator: " - ",
        applyLabel: "Appliquer",
        cancelLabel: "Annuler",
        weekLabel: "S",
        customRangeLabel: "Plage de dates",
        daysOfWeek: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
        monthNames: [
          "Jan",
          "Févr",
          "Mars",
          "Avr",
          "Mai",
          "Juin",
          "Juill",
          "Août",
          "Sept",
          "Oct",
          "Nov",
          "Déc"
        ],
        firstDay: 1
      },
      ranges: {
        "Aujourd'hui": [new Date(), new Date()],
        Hier: [
          moment()
            .subtract(1, "day")
            .toDate(),
          moment()
            .subtract(1, "day")
            .toDate()
        ],
        "Cette semaine": [
          moment()
            .day(1)
            .toDate(),
          moment().toDate()
        ],
        "Ce mois-ci": [
          moment()
            .date(1)
            .toDate(),
          moment().toDate()
        ],
        "Cette année": [
          moment()
            .month(0)
            .date(1)
            .toDate(),
          moment().toDate()
        ],
        "L'année dernière": [
          moment()
            .subtract(1, "year")
            .month(0)
            .date(1)
            .toDate(),
          moment()
            .subtract(1, "year")
            .month(11)
            .date(31)
            .toDate()
        ]
      },
      summary: {},
      summaryFields: [
        {
          key: "type",
          label: "Type"
        },
        {
          key: "total",
          label: "HTVA",
          formatter: value =>
            Number(value).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }) + " €",
          class: "text-right"
        },
        {
          key: "totalTVA",
          label: "TVA",
          formatter: value =>
            value.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }) + " €",
          class: "text-right"
        },
        {
          key: "totalTVAC",
          label: "TVAC",
          formatter: (value, key, item) =>
            (item.totalTVA + item.total).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }) + " €",
          class: "text-right"
        }
      ],
      items: [
        {
          text: "Gestion",
          to: { name: "home" }
        },
        {
          text: "Factures",
          to: { name: "invoices" }
        },
        {
          text: "Tableau comptable",
          to: { name: "chartAccounts" }
        }
      ]
    };
  },
  mounted() {
    this.updateChart();
  },
  methods: {
    company(str) {
      return String.company(str);
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    previousTime() {
      if (!(this.dateRange.startDate instanceof moment)) {
        this.dateRange.startDate = moment(this.dateRange.startDate);
        this.dateRange.endDate = moment(this.dateRange.endDate);
      }
      switch (this.selectedChartType) {
        case "year":
          this.dateRange.startDate = this.dateRange.startDate.subtract(
            1,
            "year"
          );
          this.dateRange.endDate = this.dateRange.endDate.subtract(1, "year");
          break;
        case "month":
          this.dateRange.startDate = this.dateRange.startDate.subtract(
            1,
            "month"
          );
          this.dateRange.endDate = this.dateRange.endDate.subtract(1, "month");
          break;
        case "day":
          this.dateRange.startDate = this.dateRange.startDate.subtract(1, "day");
          this.dateRange.endDate = this.dateRange.endDate.subtract(1, "day");
          break;
      }
      
      this.updateChart();
    },
    nextTime() {
      if (!(this.dateRange.startDate instanceof moment)) {
        this.dateRange.startDate = moment(this.dateRange.startDate);
        this.dateRange.endDate = moment(this.dateRange.endDate);
      }
      switch (this.selectedChartType) {
        case "year":
          this.dateRange.startDate = this.dateRange.startDate.add(1, "year");
          this.dateRange.endDate = this.dateRange.endDate.add(1, "year");
          break;
        case "month":
          this.dateRange.startDate = this.dateRange.startDate.add(1, "month");
          this.dateRange.endDate = this.dateRange.endDate.add(1, "month");
          break;
        case "day":
          this.dateRange.startDate = this.dateRange.startDate.add(1, "day");
          this.dateRange.endDate = this.dateRange.endDate.add(1, "day");
          break;
      }
      
      this.updateChart();
    },
    updateChart() {
      if (this.$refs.chart) {
        this.$refs.chart.chart.showLoading();
      }
      if (!(this.dateRange.startDate instanceof moment)) {
        this.dateRange.startDate = moment(this.dateRange.startDate);
        this.dateRange.endDate = moment(this.dateRange.endDate);
      }
      this.query = [
        {
          sql:
            "facture.date >= '" +
            this.dateRange.startDate.format("YYYY-MM-DD") +
            "' AND facture.date <= '" +
            this.dateRange.endDate.format("YYYY-MM-DD") +
            "'"
        }
      ];
      this.componentKey += 1; // Force refreshing b-table-list
      this.updateRender += 1; // Force refreshing date-time-picker
      invoices
        .chartAccounts(
          this.dateRange.startDate.format("YYYY-MM-DD"),
          this.dateRange.endDate.format("YYYY-MM-DD"),
          this.selectedChartType
        )
        .then(response => {
          if (this.$refs.chart) {
            this.$refs.chart.chart.hideLoading();
          }
          if (!response.data.summary) {
            this.noData = true;
            return;
          }
          this.noData = false;
          this.summary = response.data.summary;
          this.loaded = true;
          let table = "data";
          let type = "column";
          let title = "Par année";
          let field = "totalHTVA";
          let series = [];
          switch (this.selectedChartType) {
            case "year":
              title = "Par année";
              break;
            case "month":
              title = "Par mois";
              break;

            case "day":
              title = "Par jour";
              break;
          }
          switch (this.selectedVATType) {
            case 1:
              field = "totalHTVA";
              break;
            case 2:
              field = "totalTVA";
              break;
            case 3:
              field = "total";
          }
          series = [
            {
              name: "Vente",
              data: response.data[table]
                .filter(x => x.type == "vente")
                .map(x => x[field])
            },
            {
              name: "Commission",
              data: response.data[table]
                .filter(x => x.type == "commission")
                .map(x => x[field])
            },
            {
              name: "Note de crédit",
              data: response.data[table]
                .filter(x => x.type == "note de credit")
                .map(x => x[field])
            },
            {
              name: "Générique",
              data: response.data[table]
                .filter(x => x.type == "generic")
                .map(x => x[field])
            }
          ];
          let that = this;
          this.charted = {
            credits: {
              enabled: false
            },
            chart: {
              type: type
            },
            title: {
              text: title
            },
            xAxis: {
              categories: [
                ...new Set(response.data[table].map(x => x["label"]))
              ],
              tickmarkPlacement: "on",
              title: {
                enabled: false
              }
            },
            yAxis: {
              title: {
                text: "Euros"
              }
            },
            plotOptions: {
              column: {
                stacking: "normal",
                lineColor: "#666666",
                lineWidth: 1,
                marker: {
                  lineWidth: 1,
                  lineColor: "#666666"
                }
              },
              series: {
                point: {
                  events: {
                    click: function() {
                      switch (that.selectedChartType) {
                        case "year":
                          that.dateRange = {
                            startDate: moment()
                              .set("year", this.category)
                              .month(0)
                              .date(1),
                            endDate: moment()
                              .set("year", this.category)
                              .month(11)
                              .date(31)
                          };
                          that.updateChart();
                          break;
                        case "month":
                          that.dateRange = {
                            startDate: moment()
                              .year(this.category.split("-")[1])
                              .month(this.category.split("-")[0])
                              .date(1),
                            endDate: moment()
                              .year(this.category.split("-")[1])
                              .month(this.category.split("-")[0])
                              .endOf("month")
                          };
                          that.updateChart();
                          break;
                      }
                    }
                  }
                }
              }
            },

            tooltip: {
              split: true,
              formatter: function() {
                return ["<b>" + this.x + "</b>"].concat(
                  this.points
                    ? this.points.map(function(point) {
                        return (
                          point.series.name +
                          ": " +
                          Number(point.y).toFixed(2) +
                          " €"
                        );
                      })
                    : []
                );
              }
            },
            series: series
          };
        });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>